import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class CardApiService extends ApiService {
    baseUrl = 'card';

    /**
     * POST для валидации и генерации файла заявки на поверку/калибровку
     */
    validateRequestCalibrationDocumentUrl = this.baseUrl + '/validate-request-calibration-document';
    generateRequestCalibrationDocumentUrl = this.baseUrl + '/generate-request-calibration-document';

    /**
     * POST для генерации документа списка оборудования
     * Request Payload:
     * {
     *     ids: number[],
     *     format: number // 1 - просто список, 2 - архив со списком и доками
     * }
     */
    generateListDocumentUrl = this.baseUrl + '/generate-list-document';

    /**
     * POST для валидации и генерации учетных карточек выбранного оборудования
     * Request Payload:
     * {
     *     ids: number[]
     * }
     */
    validateCardDocumentUrl = this.baseUrl + '/validate-card-document';
    generateCardDocumentUrl = this.baseUrl + '/generate-card-document';
}
